import {Box, FormControlLabel} from '@mui/material';
import ArrModal from '../arr-modal/ArrModal';
import ArrButton from '../arr-button/ArrButton';
import ArrCheckbox from '../arr-checkbox/ArrCheckbox';
import './ArrWaitToCompleteModal.scss';
import {useTranslation} from 'react-i18next';

interface ArrWaitToCompleteModalProps {
  showModal: boolean;
  showAgain: boolean;
  doNotShowAgain: boolean;
  setDoNotShowAgain: (value: boolean) => void;
  onYes: () => void;
  onCloseNo: () => void;
  onCancel: () => void;
  onOutsideClick?: () => void;
  showClose?: boolean;
}

const ArrWaitToCompleteModal = ({
  showModal,
  showAgain,
  doNotShowAgain,
  setDoNotShowAgain,
  onYes,
  onCloseNo,
  onCancel,
  onOutsideClick,
  showClose = true,
}: ArrWaitToCompleteModalProps) => {
  const {t} = useTranslation();
  return (
    <Box>
      <ArrModal
        showModal={showModal}
        className="modal-box"
        title={t('waitToComplete.waitForTask')}
        description={t('waitToComplete.description')}
        showClose={showClose}
        dataTestId="arr-waittocomplete-modal"
        buttons={[
          {
            id: 'no',
            label: t('common.no'),
            onClick: onCloseNo,
            variant: 'secondary',
            dataTestId: 'wtcm-no-btn',
          },
          {
            id: 'yes',
            label: t('common.yes'),
            onClick: onYes,
            variant: 'primary',
            dataTestId: 'wtcm-yes-btn',
          },
        ]}
        footer={
          <Box className="cancel-row">
            <ArrButton
              variant="text"
              onClick={onCancel}
              size="medium"
              dataTestId="arr-wait-to-complete-modal-cancel-button"
            >
              {t('common.cancel')}
            </ArrButton>
          </Box>
        }
        onClose={onCancel}
        onBackdropClick={onOutsideClick}
        autoFocusCloseButton={true}
      >
        {showAgain && (
          <Box className="modal-actions" data-testid="do-not-show-again">
            <FormControlLabel
              data-testid="consent-text"
              className="consent-text"
              control={
                <ArrCheckbox
                  aria-label={t('waitToComplete.doNotPrompt')}
                  checked={doNotShowAgain}
                  onChange={(checked) => setDoNotShowAgain(checked)}
                />
              }
              classes={{label: 'consent-text'}}
              label={t('waitToComplete.doNotPrompt')}
            />
          </Box>
        )}
      </ArrModal>
    </Box>
  );
};

export default ArrWaitToCompleteModal;
